module.exports = __webpack_public_path__ + "img/plans-and-upgrades.368155eb.svg";